import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantService } from '../services/tenant.service';
import { StorageService } from '../services/storage.service';

/**
 * Guard para redireccionar desde la raíz según el contexto
 * - Dominio central (localhost:4200) → /login (owner)
 * - Subdominio tenant (supermax.localhost:4200) → /employee/login o /app/dashboard
 */
export const contextRedirectGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const tenantService = inject(TenantService);
  const storageService = inject(StorageService);

  // Detectar si estamos en un subdominio de tenant
  const tenantSlug = tenantService.detectTenantFromDomain();
  
  console.log('🌐 Context Redirect Guard');
  console.log('📍 Hostname:', window.location.hostname);
  console.log('🏢 Tenant Slug:', tenantSlug);
  
  if (tenantSlug) {
    // CONTEXTO DE TENANT (subdominio)
    console.log('✅ Contexto: TENANT');
    
    const employeeToken = storageService.getEmployeeToken();
    
    if (employeeToken) {
      console.log('🔑 Empleado autenticado → /app/dashboard');
      return router.createUrlTree(['/app/dashboard']);
    } else {
      console.log('🔓 Sin sesión → /employee/login');
      return router.createUrlTree(['/employee/login']);
    }
  } else {
    // CONTEXTO CENTRAL (sin subdominio)
    console.log('✅ Contexto: CENTRAL');
    console.log('📋 Redirigiendo a /login');
    return router.createUrlTree(['/login']);
  }
};
